import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import HotelDetails from './HotelDetails';

function HotelDetailsFunc() {
  const location = useLocation();
  const navigate = useNavigate();

  return <HotelDetails location={location} navigate={navigate} />;
}

export default HotelDetailsFunc;
